$(function () {
  $(window).scroll(sticky_relocate);
  sticky_relocate();
});
function sticky_relocate() {
  var window_top = $(window).scrollTop();
  if (window_top > 10) {
    $("#Navigation").addClass("stick-header stick-inner-header");
  } else {
    $("#Navigation").removeClass("stick-header stick-inner-header");
  }
}
$(document).ready(function () {
  if ($(window).width() < 992) {
    $(document).on("click", ".mobile-tabs .nav-item", function (event) {
      $(this).parent().prepend($(this));
      $(".mobile-tabs .nav-item").toggleClass("visible-xs visible-sm");
    });
  }
});

$(".mb-menu").removeAttr("id");
$(".mb-menu").removeClass("collapse");
$("#menu-header-menu .mega-menu").prepend('<i class="fas pluse fa-plus"></i>');

$("#menu-header-menu li .fas").click(function () {
  if ($(this).parent().find(".sub-menu").hasClass("open")) {
    $(".sub-menu").removeClass("open");
    $(this).addClass("fa-plus").removeClass("fa-minus");
  } else {
    $(".sub-menu").removeClass("open");
    $("#menu-header-menu li .fas").addClass("fa-plus").removeClass("fa-minus");
    $(this).parent().find(".sub-menu").addClass("open");
    $(this).removeClass("fa-plus").addClass("fa-minus");
    $(this).closest(".sub-menu").addClass("open");
  }
});
$(document).ready(function () {
  $("#pagination1 #data-page1 a").trigger("click");
  $("#pagination1 #data-page1").addClass("active");
  $("#pagination2 #data-page1 a").trigger("click");
  $("#pagination2 #data-page1").addClass("active");
  $("#pagination3 #data-page1 a").trigger("click");
  $("#pagination3 #data-page1").addClass("active");
  $("#pagination4 #data-page1 a").trigger("click");
  $("#pagination4 #data-page1").addClass("active");
});